module.exports = __webpack_public_path__ + "static/media/ryan_tran.44c89b1a.png";